module.exports = __webpack_public_path__ + "img/people-union.1bfdc83a.svg";